import { LanguageType } from 'app/shared/model/enumerations/language-type.model';

export interface IErrorMessage {
  id?: number;
  language?: keyof typeof LanguageType;
  errorCode?: string;
  message?: string;
  errorName?: string | null;
}

export const defaultValue: Readonly<IErrorMessage> = {};
